var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-avatar',_vm._g({attrs:{"size":"26","color":_vm.iconColor}},on),[_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }